<template>
  <div>
    <router-view :key="$route.path"></router-view>
    <dara-modal-change-password
      v-if="showModal()"
      :user="getUser()">
    </dara-modal-change-password>
  </div>
</template>

<script>
import { getters } from '@/modules/user/user.store';

export default {
  name: 'DaraApp',
  provide() {
    const userEditVm = {};
    Object.defineProperty(userEditVm, 'user', {
      get: () => getters.getUser(),
    });
    return { userEditVm };
  },
  methods: {
    showModal() {
      return getters.getUser() && !getters.getUser().verified;
    },
    getUser() {
      return getters.getUser();
    },
  },
};
</script>

<style lang="scss">
@import '@/scss/app';
</style>
